import { createFileRoute, redirect } from '@tanstack/react-router'

import { MENU } from '@/constants/common/message.constants'
import { getDefaultUserMeTenant } from '@/features/auth/models'
import { USER_TYPE } from '@/libs/api/types'

export const Route = createFileRoute(
  '/_protected/$tenantKey/settings/customers/create'
)({
  meta: () => [{ title: MENU.REGISTERING_CUSTOMER }],
  beforeLoad: ({ context: { auth } }) => {
    if (auth?.user?.type !== USER_TYPE.OWNER) {
      // DCユーザー以外の場合は荷主一覧にリダイレクト
      throw redirect({
        to: `/${getDefaultUserMeTenant(auth.user).key}/settings/customers`
      })
    }
  }
})
